import type { TeamMemberLimitsData } from './teamManagement.repository';

export const getTeamMemberLimitProhibitsAdd = (teamMemberLimits?: TeamMemberLimitsData) => {
  const remainingLimit = teamMemberLimits ? teamMemberLimits.limit - teamMemberLimits.used : 0;
  return !teamMemberLimits || remainingLimit < 1;
};
